<template>
  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
export default {
  data() {
    return {
      list: [
        {
          name: '当前库存',
          url: '/fire/foodModuleIndex/inventoryIndex/inventory'
        },
        {
          name: '采购记录',
          url: '/fire/foodModuleIndex/inventoryIndex/purchaseRecode'
        },
        {
          name: '消耗记录',
          url: '/fire/foodModuleIndex/inventoryIndex/consumptionRecord'
        }
      ]
    }
  },
  mounted() {
    config()
    this.$nextTick(() => {
      this.$bus.emit('isShowTopMenu', true)
      this.$bus.emit('getTopMenuList', this.list)
    })
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>